export default __webpack_public_path__ + "static/media/timepoint-first.52b1f65c.svg";